export function whenOnline(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        if (navigator.onLine) {
            resolve();
        } else {
            window.addEventListener('online', () => resolve(), { once: true });
        }
    });
}
